import { createFileRoute } from '@tanstack/react-router'

import { ListPageHeader } from '@/components/common/ListPageHeader'
import { SiteSettingForm } from '@/components/retail/cms/site-setting-form'
import { kindLabel } from '@/components/retail/cms/site-settings-model'
import { HomeCatalogProvider } from '@/components/retail/home-link-field'
import { Card, CardContent } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useAuth } from '@/hooks/use-auth'
import { useShopSiteSettings } from '@/hooks/use-shop-site-settings-query'
import { m } from '@/lib/paraglide/messages'

// Bán lẻ › Cài đặt website: chữ quảng bá, link, SEO… của website và Mini App
// (trước đây viết cứng trong code). Mỗi tab là một kind, lưu riêng.
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/retail/site-settings',
)({
    component: SiteSettingsPage,
})

export function SiteSettingsPage() {
    const { hasPermission } = useAuth()
    const canWrite = hasPermission('shop_content.write')
    const canCatalog = hasPermission('shop_catalog.read')
    const query = useShopSiteSettings()
    const settings = query.data?.data?.settings ?? []

    let body
    if (query.isLoading)
        body = (
            <p className="text-sm text-muted-foreground">
                {m.common_loading()}
            </p>
        )
    else if (query.isError || settings.length === 0)
        body = (
            <p className="text-sm text-destructive" role="alert">
                {m.siteSettings_load_failed()}
            </p>
        )
    else
        body = (
            // Giữ mọi tab trong DOM (forceMount) để chuyển tab không mất chữ đang sửa.
            <Tabs defaultValue={settings[0].kind} className="space-y-3">
                <TabsList className="h-auto max-w-full flex-wrap justify-start">
                    {settings.map((s) => (
                        <TabsTrigger key={s.kind} value={s.kind}>
                            {kindLabel(s.kind)}
                        </TabsTrigger>
                    ))}
                </TabsList>
                {settings.map((s) => (
                    <TabsContent
                        key={s.kind}
                        value={s.kind}
                        forceMount
                        className="data-[state=inactive]:hidden"
                    >
                        <Card className="max-w-3xl">
                            <CardContent className="pt-6">
                                <SiteSettingForm
                                    key={s.version}
                                    setting={s}
                                    canWrite={canWrite}
                                    onReload={() => void query.refetch()}
                                />
                            </CardContent>
                        </Card>
                    </TabsContent>
                ))}
            </Tabs>
        )

    return (
        <div className="space-y-4 page-pad">
            <ListPageHeader
                title={m.siteSettings_title()}
                subtitle={m.siteSettings_subtitle()}
            />
            {canCatalog ? (
                <HomeCatalogProvider>{body}</HomeCatalogProvider>
            ) : (
                body
            )}
        </div>
    )
}
